import React from 'react';

export interface EmbeddedHtmlProps {
	content?: string;
}

export const EmbeddedHtml = ({ content }: EmbeddedHtmlProps): JSX.Element => {
	return content ? <div dangerouslySetInnerHTML={{ __html: content }} /> : <></>;
};
